import { createContext, useContext, useState, useEffect, useCallback, ReactNode } from "react";

interface RouterContextType {
  path: string;
  navigate: (to: string) => void;
}

const RouterContext = createContext<RouterContextType>({
  path: "/",
  navigate: () => {},
});

export function ClientRouter({ children }: { children: ReactNode }) {
  const [path, setPath] = useState(() => window.location.pathname || "/");

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname || "/");
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback((to: string) => {
    if (window.location.pathname !== to) {
      window.history.pushState(null, "", to);
    }
    setPath(to);
  }, []);

  return (
    <RouterContext.Provider value={{ path, navigate }}>
      {children}
    </RouterContext.Provider>
  );
}

export function useClientRouter() {
  return useContext(RouterContext);
}

interface LinkProps {
  to: string;
  className?: string;
  children: ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

export function ClientLink({ to, className, children, title, style }: LinkProps) {
  const { navigate } = useClientRouter();
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(to);
  };
  return (
    <a href={to} onClick={handleClick} className={className} title={title} style={style}>
      {children}
    </a>
  );
}
